import { StatesButtonStates, StatesButton as TPAButton, Spinner, PaddingModes, HoverStyles } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React from 'react';
import { DATA_HOOKS } from '../../../../constants';
import { ForcedState, useForcedState } from '../../../../contexts/forced-state-context';
import { Widget } from '../../../../ui/widget/widget';
import NextButton from './next-button/next-button';
import PreviousButton from './previous-button/previous-button';
import { classes } from './submit-button-wut.st.css';
const InProgressLoader = ({ submitText })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        "aria-hidden": "true",
        className: classes.hiddenText
    }, submitText), /*#__PURE__*/ React.createElement(Spinner, {
        className: classes.spinner
    }));
};
const Submit = ({ onClick, disabled, submitText, hasSteps, inProgress })=>{
    const forcedState = useForcedState();
    const hover = forcedState.includes(ForcedState.SUBMIT_BUTTON_HOVER);
    return /*#__PURE__*/ React.createElement(TPAButton, {
        className: classNames(classes.button, {
            [classes.buttonNoSteps]: !hasSteps,
            [classes.buttonWithSteps]: hasSteps,
            [classes.hover]: hover,
            [classes.navigationButtons]: hasSteps,
            [classes.inProgress]: inProgress
        }),
        hoverStyle: HoverStyles.underline,
        upgrade: true,
        wrapContent: true,
        onClick: onClick,
        disabled: disabled,
        state: inProgress ? StatesButtonStates.IN_PROGRESS : StatesButtonStates.IDLE,
        inProgressContent: /*#__PURE__*/ React.createElement(InProgressLoader, {
            submitText: submitText
        }),
        idleContent: submitText,
        paddingMode: PaddingModes.explicitPaddings,
        "data-hook": DATA_HOOKS.SUBMIT_BUTTON
    });
};
export const SubmitButtonWUT = ({ submitText, text, id, previousText, nextText, FieldLayout, hasSteps, showPreviousButton, showNextButton, showSubmitButton, onSubmitClick, onPreviousClick, onNextClick, isDisabled, isInProgress, widgetHtml, widgetEnabled })=>{
    const submitButtonText = submitText || text || '';
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>null,
        renderInput: ()=>widgetHtml && widgetEnabled ? /*#__PURE__*/ React.createElement(Widget, {
                fieldId: id,
                widgetHtml: widgetHtml,
                onChange: ()=>{},
                value: null
            }) : /*#__PURE__*/ React.createElement("div", {
                className: classNames({
                    [classes.navigationContainer]: hasSteps,
                    [classes.rowSpacing]: showPreviousButton
                })
            }, showPreviousButton && /*#__PURE__*/ React.createElement(PreviousButton, {
                previousText: previousText,
                className: classes.navigationButtons,
                onClick: onPreviousClick
            }), showNextButton && /*#__PURE__*/ React.createElement(NextButton, {
                nextText: nextText,
                className: classes.navigationButtons,
                onClick: onNextClick
            }), showSubmitButton && /*#__PURE__*/ React.createElement(Submit, {
                onClick: ()=>onSubmitClick?.(),
                disabled: isDisabled,
                submitText: submitButtonText,
                hasSteps: hasSteps,
                inProgress: isInProgress
            })),
        renderDescription: ()=>null
    });
};

//# sourceMappingURL=submit-button-wut.js.map